import { EnqueueSnackbar } from 'notistack'

import Api from '../../utils/api'

export const parseNotificationPreferences = (preferences: string | string[] | undefined) => {
  return Array.isArray(preferences) ? preferences : preferences ? JSON.parse(JSON.stringify(preferences)) : []
}

export const onDragEnd = async ({
  setIsDragging,
  setReplaceFirstContactDialogOpen,
  selectedFolderId,
  values,
  prevValues,
  setParentValues,
  parentEl,
  enqueueSnackbar,
}: {
  setIsDragging: (isDragging: boolean) => void
  setReplaceFirstContactDialogOpen: (open: boolean) => void
  selectedFolderId: number | null
  values: INotificationContact[]
  prevValues: React.RefObject<INotificationContact[]>
  setParentValues: (values: INotificationContact[], parent: HTMLElement) => void
  parentEl: HTMLElement
  enqueueSnackbar: EnqueueSnackbar
}) => {
  setIsDragging(false)

  if (!Array.isArray(values) || values.length === 0 || !Array.isArray(prevValues.current) || prevValues.current.length === 0) {
    return
  }

  const isCallCenterRole = (roleName?: string) => roleName?.toLowerCase().includes('call center')

  // If there was no change in the order, do nothing
  if (JSON.stringify(values.map((v) => v.user.id)) === JSON.stringify(prevValues.current.map((v) => v.user.id))) {
    return
  }

  // If Call Center in first position is being replaced, show dialog to confirm before making the change
  if (isCallCenterRole(prevValues.current[0].user.role?.name) && !isCallCenterRole(values[0].user.role?.name)) {
    setReplaceFirstContactDialogOpen(true)
    return
  }

  try {
    const res = await Api.post(`/api/v2/protect/folders/${selectedFolderId}/notification-priority`, {
      userIds: (values as INotificationContact[]).map((i) => i.user.id),
    })
    if (!res.ok) throw res
    if (prevValues.current[0].user.id !== values[0].user.id) {
      enqueueSnackbar('Primary contact changed')
    } else {
      enqueueSnackbar('Contact priority updated')
    }
    // eslint-disable-next-line no-param-reassign
    prevValues.current = values
  } catch {
    setParentValues(prevValues.current, parentEl)
    enqueueSnackbar('There was a problem sorting the contacts.', { variant: 'error' })
  }
}

export const onReplaceFirstContact = async ({
  selectedFolderId,
  notificationContacts,
  prevContacts,
  setNotificationContacts,
  setReplaceFirstContactDialogOpen,
  setDialogButtonLoading,
  enqueueSnackbar,
}: {
  selectedFolderId: number | null
  notificationContacts: INotificationContact[]
  prevContacts: React.RefObject<INotificationContact[]>
  setNotificationContacts: (values: INotificationContact[]) => void
  setReplaceFirstContactDialogOpen: (open: boolean) => void
  setDialogButtonLoading: (loading: boolean) => void
  enqueueSnackbar: EnqueueSnackbar
}) => {
  // Update notification priority
  // Close dialog
  // Reset button loading state
  try {
    const res = await Api.post(`/api/v2/protect/folders/${selectedFolderId}/notification-priority`, {
      userIds: notificationContacts.map((i) => i.user.id),
    })
    if (!res.ok) throw res
    enqueueSnackbar('Primary contact changed')
    // eslint-disable-next-line no-param-reassign
    prevContacts.current = notificationContacts
  } catch {
    setNotificationContacts(prevContacts.current)
    enqueueSnackbar('There was a problem sorting the contacts.', { variant: 'error' })
  } finally {
    setReplaceFirstContactDialogOpen(false)
    setDialogButtonLoading(false)
  }
}
